import type { FactionId } from './faction';

/** Flag narrativo: valor booleano asociado a un id. */
export type NarrativeFlags = Record<string, boolean>;

/** Registro de una decisión tomada. */
export interface DecisionLogEntry {
  id: string;
  timestamp: number;
  sceneId: string;
  choiceId: string;
  textoOpcion: string;
  /** Si la consecuencia es inmediata, acá va la descripción. */
  impactoInmediato?: string;
  /** Si la consecuencia es diferida, acá va el id del consequence pendiente. */
  consequencePendiente?: string;
  /** Cuando la consecuencia diferida se resuelve, se rellena. */
  impactoDiferidoResuelto?: string;
}

export interface PendingConsequence {
  id: string;
  /** Escena o evento que dispara su resolución. */
  triggeredBy: string;
  /** Descripción opaca al jugador mientras está pendiente. */
  resumenOpaco: string;
  /** IDs de DecisionLogEntry asociadas (para actualizar cuando se resuelva). */
  decisionEntryIds: string[];
}

export type LocationId =
  | 'hogar_ruinas'
  | 'bosque_susurrante'
  | 'villa_capibarica'
  | 'rio_ancestral'
  | 'acantilados_olvidados'
  | 'santuario'
  | 'guarida_sombra'
  | 'laguna_sagrada'
  | 'tierras_quemadas'
  | 'corazon_civilizacion';

export interface WorldState {
  locacionActual: LocationId;
  locacionesDesbloqueadas: LocationId[];
  reputacion: Record<FactionId, number>;
  flags: NarrativeFlags;
  consecuenciasPendientes: PendingConsequence[];
}

export interface NarrativeState {
  sceneIdActual: string | null;
  capituloActual: number;
  historialEscenas: string[];
  decisiones: DecisionLogEntry[];
  /** Si ya se alcanzó un final, cuál. */
  finalAlcanzado: string | null;
}

export interface GameSettings {
  volumenMusica: number;
  volumenSfx: number;
  velocidadTexto: 'lenta' | 'normal' | 'rapida' | 'instantanea';
  efectosActivos: boolean;
  mostrarAyudaContextual: boolean;
}

export const SETTINGS_DEFAULT: GameSettings = {
  volumenMusica: 0.5,
  volumenSfx: 0.7,
  velocidadTexto: 'normal',
  efectosActivos: true,
  mostrarAyudaContextual: true,
};
